import React, { useState, useEffect } from 'react';
import './InsightsPopup.css';
import OptimizedImage from './OptimizedImage';
import popupImage from 'url:../../assets-optimized/redesign/insights/contact.png';
import popupImageavif from 'url:../../assets-optimized/redesign/insights/contact.avif';
import popupImagewebp from 'url:../../assets-optimized/redesign/insights/contact.webp';

const InsightsPopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
  });
  const [status, setStatus] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const [render, setRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setRender(true);
      setIsClosing(false);
    } else if (render) {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setRender(false);
        setIsClosing(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen, render]);

  if (!render) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('insights-popup-overlay')) {
      onClose();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.email || !formData.company) {
      return;
    }
    setStatus('submitting');
    setTimeout(() => {
      setStatus('success');
      setTimeout(() => {
        onClose();
        setStatus(null);
        setFormData({ fullName: '', email: '', company: '' });
      }, 2000);
    }, 1000);
  };

  return (
    <div className={`insights-popup-overlay ${isClosing ? 'closing' : ''}`} onClick={handleOverlayClick}>
      <div className={`insights-popup-content ${isClosing ? 'closing' : ''}`}>
        <button className="insights-popup-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div className="insights-popup-left">
          <OptimizedImage avif={popupImageavif} webp={popupImagewebp} fallback={popupImage} alt="Travel Trends" className="insights-popup-bg" />
          <div className="insights-popup-title">
            <h2>STAY AHEAD OF<br/>TRAVEL TRENDS<br/>DRIVING PURCHASE<br/>DECISIONS</h2>
          </div>
        </div>
        <div className="insights-popup-right">
          <div className="insights-popup-text">
            <p>Access exclusive data, expert perspectives, and emerging travel trends to master the journey-based approach to marketing.</p>
            <p className="insights-popup-bold">Enter your email and be the first to receive our next full report and stay ahead with future insights.</p>
          </div>
          {status === 'success' ? (
            <div className="insights-popup-success">
              <h3>Thank you!</h3>
              <p>We'll notify you when our next report is ready.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="insights-popup-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fullName">FIRST AND LAST NAME*</label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    placeholder="First and Last Name"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">WORK EMAIL*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="example@youremail.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group full-width">
                  <label htmlFor="company">COMPANY*</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    placeholder="Company Name"
                    value={formData.company}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <button type="submit" className="insights-popup-submit" disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Submitting...' : 'Notify Me'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsightsPopup;